/**
 * Shared knobs for deferring Motion-backed decorative islands until near
 * the viewport or the main thread is idle — avoids early hydration without CLS.
 */

/** Expand the IO root so islands mount shortly before they scroll on-screen. */
export const DEFERRED_MOUNT_ROOT_MARGIN = '30% 0px' as const;

/** Fallback idle timeout when the island never approaches the viewport. */
export const DEFERRED_MOUNT_IDLE_TIMEOUT_MS = 3000;
